module.exports = __webpack_public_path__ + "img/random_icon.b57ea6fd.png";